import React, { useMemo, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { convertLocalDate } from "../../../../Utils/configController";
import LogsDataTable from "./LogsDataTable";
import { Col, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import { useEffect, useRef } from "react";
import { jsPlumb } from "jsplumb";
export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

const AutomationList = ({ userId, selectedPremise }: ChipsControlProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isAutomationModalOpen, setIsAutomationModalOpen] = useState(false);
  const [selectedAutomationList, setSelectedAutomationList] =
    useState<any>(null);

  const columns = [
    {
      name: "Name",
      selector: (row: any) => row?.name || "-",
      cell: (row: any) => <div>{row?.name || "-"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Any Situation",
      selector: (row: any) => (row?.isAnySituation ? "True" : "False"),
      cell: (row: any) => <div>{row?.isAnySituation ? "True" : "False"}</div>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row?.status ? "True" : "False"),
      cell: (row: any) => <div>{row?.status ? "True" : "False"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Last Execute Date",
      selector: (row: any) => row?.lastExeculateDateTime || "",
      cell: (row: any) => (
        <div>
          {row?.lastExeculateDateTime
            ? convertLocalDate(row.lastExeculateDateTime)
            : "-"}
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Effective Start",
      selector: (row: any) => row?.effectiveTimePeriodStart || "",
      cell: (row: any) => <div>{row?.effectiveTimePeriodStart || "-"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Effective End",
      selector: (row: any) => row?.effectiveTimePeriodEnd || "",
      cell: (row: any) => <div>{row?.effectiveTimePeriodEnd || "-"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Is Active",
      selector: (row: any) => (row?.isActive ? "Yes" : "No"),
      cell: (row: any) => <div>{row?.isActive ? "Yes" : "No"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Next Active Effective",
      selector: (row: any) => row?.nextActiveEffectiveDateTime || "",
      cell: (row: any) => (
        <div>
          {row?.nextActiveEffectiveDateTime
            ? convertLocalDate(row.nextActiveEffectiveDateTime)
            : "-"}
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Notification Subscribed",
      selector: (row: any) => (row?.isNotificationSubscribed ? "Yes" : "No"),
      cell: (row: any) => (
        <div>{row?.isNotificationSubscribed ? "Yes" : "No"}</div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Details",
      cell: (row: any) => {
        return (
          <button
            className="btn btn-dark btn-sm"
            onClick={() => {
              setSelectedAutomationList(row || {});
              setIsAutomationModalOpen(true);
            }}
          >
            View
          </button>
        );
      },
      sortable: false,
      wrap: true,
    },
  ];

  return (
    <div>
      <LogsDataTable
        apiURL={`${url.BASE_URL}${url.GET_AUTOMATION_LIST}`}
        title="Automation List"
        columns={columns}
        loading={loading}
        setLoading={setLoading}
        userId={userId}
        selectedPremise={selectedPremise}
      />
      <SharedUsersModal
        isAutomationModalOpen={isAutomationModalOpen}
        selectedAutomationList={selectedAutomationList}
        onClose={() => {
          setIsAutomationModalOpen(false);
          setSelectedAutomationList(null);
        }}
      />
    </div>
  );
};

export default AutomationList;

function SharedUsersModal({
  isAutomationModalOpen,
  selectedAutomationList,
  onClose,
}: any) {
  return (
    <Modal
      isOpen={isAutomationModalOpen}
      className="modal-xl"
      style={{
        backgroundColor: "#F7F7FA",
        borderRadius: "12px",
        padding: "0px",
      }}
      role="dialog"
      autoFocus={true}
      toggle={onClose}
    >
      <div className="modal-header justify-content-between">
        <h5 className="modal-title">Automation</h5>
        <button
          className="btn p-0"
          style={{ border: "none" }}
          onClick={onClose}
        >
          <box-icon name="x" size="30px"></box-icon>
        </button>
      </div>

      <ModalBody style={{ padding: "12px", backgroundColor: "#F7F7FA" }}>
        <Row>
          <AutomationFlow automation={selectedAutomationList} />
        </Row>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-outline-secondary" onClick={onClose}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
}

function AutomationFlow({ automation }: { automation?: any }) {
  const conditions = automation?.condition || [];
  const actions = automation?.action || [];
  const isAny = automation?.isAnySituation;
  const containerRef = useRef<any>(null);

  const gap = 40;

  useEffect(() => {
    if (!containerRef.current) return;

    const instance = jsPlumb.getInstance({
      Connector: ["Bezier", { curviness: 90 }],
      Anchors: ["RightMiddle", "LeftMiddle"],
      PaintStyle: { stroke: "#555", strokeWidth: 3 },
      Endpoint: "Blank",
      Container: containerRef.current,
    });

    instance.setContainer(containerRef.current);

    // connect each condition to merge node
    if (isAny) {
      conditions.forEach((c: any, i: any) => {
        instance.connect({
          source: `cond-${i}`,
          target: "action-panel",
          overlays: [["Arrow", { location: 1, width: 15, length: 15 }]],
        });
      });
    } else {
      instance.connect({
        source: `condition-panel`,
        target: "action-panel",
        overlays: [["Arrow", { location: 1, width: 15, length: 15 }]],
      });
    }
    return () => instance.reset();
  }, [conditions, actions, isAny]);

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: 20,
      }}
    >
      <div
        ref={containerRef}
        style={{
          // width: "100%",
          width: "1100px",
          padding: 40,
          display: "flex",
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* LEFT CONDITIONS */}
        <div
          id="condition-panel"
          style={
            isAny
              ? { marginRight: 150, position: "relative" }
              : {
                  background: "#fff",
                  border: "2px solid #777",
                  borderRadius: 14,
                  width: 340,
                  padding: 25,
                  marginRight: 150,
                  position: "relative",
                }
          }
        >
          <p
            style={{
              position: "absolute",
              top: -40,
              left: "50%",
              transform: "translateX(-50%)",
              background: "black",
              color: "white",
              padding: "2px 8px",
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Conditions
          </p>

          {conditions?.map((c: any, i: number) => (
            <div
              key={i}
              id={`cond-${i}`}
              style={{
                width: 286,
                background: "#fff",
                border: "2px solid #aaa",
                borderRadius: 12,
                padding: 12,
                marginBottom: gap,
                fontFamily: "sans-serif",
              }}
            >
              {/* TITLE */}
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                {c.label || "(no label)"}
              </div>

              {Object.entries(c).map(([key, value]) => {
                if (
                  key === "label" ||
                  key === "_id" ||
                  key === "chipId" ||
                  key === "chipSwitchId" ||
                  key === "id"
                )
                  return null;
                if (!value) return null;

                return (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>{key}</span>
                    <span style={{ color: "#444" }}>
                      {String(value || "-")}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        {/* ACTION PANEL */}
        <div
          id="action-panel"
          style={{
            background: "#fff",
            border: "2px solid #777",
            borderRadius: 14,
            width: 340,
            padding: 25,
            marginLeft: 180,
            position: "relative",
          }}
        >
          <p
            style={{
              position: "absolute",
              top: -40,
              left: "50%",
              transform: "translateX(-50%)",
              background: "black",
              color: "white",
              padding: "2px 8px",
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Actions
          </p>
          {actions.map((a: any, i: any) => (
            <div
              key={i}
              style={{
                background: "#fff",
                border: "2px solid #aaa",
                borderRadius: 12,
                width: 286,
                padding: "12px 16px",
                marginBottom: 20,
                fontWeight: 600,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 15,
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                {a?.label || "(no label)"}
              </div>

              {/* KEY VALUE PAIRS */}
              {Object.entries(a).map(([key, value]) => {
                if (
                  key === "label" ||
                  key === "_id" ||
                  key === "chipId" ||
                  key === "chipSwitchId" ||
                  key === "id"
                )
                  return null;
                if (!value) return null;
                return (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>{key}:</span>
                    <span style={{ color: "#444" }}>
                      {String(value || "-")}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
